import { ProtectedRoute } from './ProtectedRoute';
import RootLayout from './RootLayout';

export default function ProtectedRootLayout() {
  return (
    <ProtectedRoute>
      <RootLayout />
    </ProtectedRoute>
  );
}
